import React, {Component} from 'react'
import {auth, db, storage} from './firebase'

class List extends Component{
    state={
        sarlavha:"",
        kitob:"",
        postlar:[],
    }
componentDidMount(){
    db.collection("sklad").onSnapshot( (kitoblar)=>{

        this.setState({
            postlar: kitoblar.docs.map((doc) => doc.data())
        })
    })
}
handlelogout = () => {
    auth.signOut()
}
handleupload = () => {
    const download = storage.ref("nn/"+this.state.kitob.name)
    .put(this.state.kitob)
    download.on(
        "state.changed",
        ()=>{},
        ()=>{},
        ()=>{
            storage.ref("/nn").child(this.state.kitob.name).getDownloadURL()
            .then((link)=>{
                db.collection("sklad").add({
                    sarlavha: this.state.sarlavha,
                    link: link,
                    razmer: this.state.kitob.size
                })
            })
        }
    )
}


    render(){
        return(
            <>
                <div>
                    <h1>kitobla royxat</h1>
                    <button onClick={this.handlelogout}>log out</button>
                    <div>
                        {
                            this.state.postlar.map(post=>{
                                return(
                                    <div>
                                        <h1>{post.sarlavha}</h1>
                                        <h1>{post.razmer}</h1>
                                        <a href={post.link}download>skachat</a>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div>
                        <input type="text" placeholder="sarlavhaa" onChange={(event)=>{
                            this.setState({sarlavha: event.target.value})
                        }}
                        />
                        <input type="file" onChange={this.handlefile}
                        />
                        <button onClick={this.handleupload}>qoysh</button>
                    </div>
                </div>
             </>
        )
    }
}
export default List